import { RefObject } from 'react';
import { Id, toast } from 'react-toastify';

const TOAST_LIST_CONTAINER_SELECTOR = '.Toastify__toast-container';
const TOAST_SELECTOR = ':scope > .Toastify__toast';
const MAX_STACKED_TOASTS = 3;
const TOAST_EVICT_MS = 120;

function getToastListContainer(root: HTMLElement): HTMLElement {
    if (root.matches(TOAST_LIST_CONTAINER_SELECTOR)) {
        return root;
    }

    return root.querySelector<HTMLElement>(TOAST_LIST_CONTAINER_SELECTOR) ?? root;
}

function getVisibleToastElements(root: HTMLElement): HTMLElement[] {
    return Array.from(getToastListContainer(root).querySelectorAll<HTMLElement>(TOAST_SELECTOR));
}

export function evictOverflowToasts(container: HTMLElement): void {
    const toasts = getVisibleToastElements(container);
    const excess = toasts.length - MAX_STACKED_TOASTS;

    if (excess <= 0) {
        return;
    }

    toasts.slice(0, excess).forEach((oldestElement) => {
        const oldestId = oldestElement.id;

        if (!oldestId) {
            return;
        }

        oldestElement.setAttribute('data-toast-evicting', 'true');
        window.setTimeout(() => {
            oldestElement.removeAttribute('data-toast-evicting');
            toast.dismiss(oldestId);
        }, TOAST_EVICT_MS);
    });
}

export function getFrontToastId(root: HTMLElement): Id | undefined {
    const toasts = Array.from(getToastListContainer(root).querySelectorAll<HTMLElement>(TOAST_SELECTOR));
    const frontToast = toasts[toasts.length - 1];
    const id = frontToast?.id;

    return id ? String(id) : undefined;
}

export function getToastContainerElement(
    containerRef: RefObject<HTMLElement | null>
): HTMLElement | null {
    const root = containerRef.current;

    if (!root) {
        return null;
    }

    return getToastListContainer(root);
}
